import * as Yup from "yup";

export const dataModel = {
  name: "",
  nif: "",
};

export const validationDataModel = (edit) => {
  return Yup.object().shape({
    name: Yup.string().required("forms.validations.required"),
    nif: Yup.string().required("forms.validations.required"),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
